/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetClassBaseResponse
 */
export interface GetClassBaseResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetClassBaseResponse
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetClassBaseResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetClassBaseResponse
     */
    description: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetClassBaseResponse
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the GetClassBaseResponse interface.
 */
export function instanceOfGetClassBaseResponse(value: object): value is GetClassBaseResponse {
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function GetClassBaseResponseFromJSON(json: any): GetClassBaseResponse {
    return GetClassBaseResponseFromJSONTyped(json, false);
}

export function GetClassBaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClassBaseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'name': json['name'],
        'description': json['description'],
        'isActive': json['isActive'],
    };
}

export function GetClassBaseResponseToJSON(json: any): GetClassBaseResponse {
    return GetClassBaseResponseToJSONTyped(json, false);
}

export function GetClassBaseResponseToJSONTyped(value?: GetClassBaseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'name': value['name'],
        'description': value['description'],
        'isActive': value['isActive'],
    };
}

